<template>
  <div class="roleContainer">
    <div class="imgBox">
      <img src="@/assets/img/exercise/applyVip.png" alt="">
      <div class="btn" @click.stop="apply"></div>
    </div>
  </div>
</template>

<script>
import { createExerciseOrder } from "@/api/meeting"
import { getUserId } from '@/widget'
export default {
  props: {
    role: {
      type: String,
      default: ''
    },
    depId: {
      type: Number,
      default: 1
    },
    skuId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    apply () {
      this.$showLoading()
      var userId = getUserId()
      var depId = this.depId;
      var sourceId = this.$route.query.sourceId || '0'
      createExerciseOrder({
        userId
      }, {
        exerciseId: this.skuId,
        sourceId,
        depId
      }).then(res => {
        if (res.code === 200) {
          this.$toast('领取成功')
          // 领取成功后刷新页面
          setTimeout(() => {
            this.$hideLoading()
            this.$emit('getCheck')
          }, 1000)
        } else {
          this.$hideLoading()
          this.$toast(res.message)
          setTimeout(() => {
            location.reload()
          }, 300)
        }
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.$emit('getCheck')
    }, 2000)
  }
}
</script>

<style lang="scss" scoped>
  .roleContainer {
    width: 750px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -375px;
    background-color: rgba($color: #000000, $alpha: 0.6);
    z-index: 9999;
    .imgBox {
      width: 540px;
      height: 622px;
      position: relative;
      left: 50%;
      margin-left: -270px;
      top: 50%;
      margin-top: -311px;
      img {
        width: 100%;
      }
      .btn {
        width: 4.6rem;
        height: 0.9rem;
        position: absolute;
        bottom: 30px;
        left: 45px;
      }
    }
  }
</style>
